import { FieldType } from '../../types/Field.type';
import { ContractOnboardingTypeRef } from '../enm/ContractOnboardingType';
export const ContractOnboardingType = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.contract_onboarding_type.label',
    fallbackLabel: 'Type of business partner onboarding',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => true,
    type: FieldType.Enum,
    options: ContractOnboardingTypeRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return true;
}
